import { render, staticRenderFns } from "./AddEditQuestionSingleImage.vue?vue&type=template&id=95ab30a8"
import script from "./AddEditQuestionSingleImage.vue?vue&type=script&lang=js"
export * from "./AddEditQuestionSingleImage.vue?vue&type=script&lang=js"
import style0 from "./AddEditQuestionSingleImage.vue?vue&type=style&index=0&id=95ab30a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports